import { palette } from "../../../theme/palette";
import { View } from "../../View";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { RouteLabel } from "../../Layers/RouteLabelLayer/RouteLabel";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
  },
  routeLabelContainer: {
    backgroundColor: palette.typography.white.high,
    borderRadius: "2px",
    padding: "3px",
    display: "inline-block",
    marginRight: "5px",
    boxShadow: "0px 0px 5px 0px grey",
    marginLeft: "3px",
  },
  delimiter: {
    height: "2px",
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, .2)",
  },
}));

export const RouteDelimiter = ({ routeCode }) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      <View className={styles.routeLabelContainer}>
        <RouteLabel routeCode={routeCode} />
      </View>
      <View className={styles.delimiter} />
    </View>
  );
};
